import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Stores", -1)
const _hoisted_2 = ["item"]

import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { Actions } from '@/store';
import { Store } from '@/models/store.model';


export default /*#__PURE__*/_defineComponent({
  __name: 'StoreList',
  setup(__props) {

const store = useStore();

const stores = computed<Store[]>(() => store.state.stores);

onMounted(() => {
  store.dispatch(Actions.GetStores);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", null, [
    _hoisted_1,
    _createElementVNode("p", null, [
      _createVNode(_component_router_link, { to: "/stores/add" }, {
        default: _withCtx(() => [
          _createTextVNode("Add store")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("ol", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(stores), (item) => {
        return (_openBlock(), _createElementBlock("li", {
          item: item,
          key: item.id
        }, [
          _createVNode(_component_router_link, {
            to: '/stores/edit/' + item.id
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ], 8, _hoisted_2))
      }), 128))
    ])
  ]))
}
}

})